import { selector } from 'recoil';
import cartSelector from './cart';
import shippingFeeAtom from '../atom/shippingFee';

import calcSettlement from '~/utils/calcSettlement';
import { sumBy } from 'lodash';

import getCouponDiscount from '~/utils/getCouponDiscount';
import { storeLocaleSelector } from './storeLocale';

const cartSettlement = selector<{
  subtotal: number;
  discount: number;
  shippingFee: number;
  freightSubsidy: number;
  total: number;
}>({
  key: 'cartSettlement',
  get: ({ get }) => {
    const store = get(storeLocaleSelector);
    const shippingFeeInfo = get(shippingFeeAtom);
    const cart = get(cartSelector);
    const { orderType, paymentType, items, coupon } = cart;

    const itemsTotal = items.reduce<number>((total, { price, count, modifiers }) => {
      const options = modifiers.map(({ options }) => options).flat();
      const itemPrice = price + sumBy(options, ({ price }) => price);
      return total + itemPrice * count;
    }, 0);

    const couponDiscount = coupon ? getCouponDiscount(coupon, itemsTotal) : 0;

    const { subtotal, shippingFee, freightSubsidy, total } = calcSettlement(
      orderType,
      paymentType,
      itemsTotal,
      couponDiscount,
      {
        shippingFee: shippingFeeInfo?.quotes || 0,
        handlingFee: store?.delivery.handlingFee || 25,
        costShare: store?.delivery?.costShare || 0,
        freeLimit: store?.delivery?.freeLimit || 0,
        costShareLimit: store?.delivery?.costShareLimit || 0,
      },
    );

    return {
      subtotal,
      discount: couponDiscount,
      shippingFee,
      freightSubsidy,
      total,
    };
  },
});

export default cartSettlement;
